import React from 'react';

export const Tienda = ({cliente, handleGenerarFicha, btnLoading}) => {

    return (
        <div>
                <p className="text-warning">Está forma de pago genera una comisión bancaria del 2.9% + $2.5 MXN más IVA por el procesamiento de este tipo de transacción, aparte el comercio puede cobrarte algun otro tipo de comisión.</p>
                <div className="row">
                    <div className="col">
                        <img style={{maxWidth: '500px', width: '100%'}} src={`${process.env.REACT_APP_API_URL}/assets/images/tiendas.png`} alt="tiendas"/>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-md-12 text-center">
                        <h6>Total con comisión:</h6>
                        <h5 className="text-success">
                            { new Intl.NumberFormat("en-US", {style: "currency", currency: "MXN"}).format(cliente.anticipo* 1.03364 + 2.5*1.16) }
                        </h5>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col d-flex align-content-center justify-content-center">
                        <button 
                            className="btn btn-primary" 
                            type="submit"
                            disabled={btnLoading}
                            onClick={() => handleGenerarFicha('store')}
                        >
                            {btnLoading && <i className="spinner-border spinner-border-sm" role="status"></i>} Generar ficha de pago
                        </button>
                    </div>
                </div>
        </div>
    )
}
